module.exports = __webpack_public_path__ + "static/media/rent.da4c7d32.png";